import { render, staticRenderFns } from "./WalletModal.vue?vue&type=template&id=33e42f61&scoped=true"
import script from "./WalletModal.vue?vue&type=script&lang=js"
export * from "./WalletModal.vue?vue&type=script&lang=js"
import style0 from "./WalletModal.vue?vue&type=style&index=0&id=33e42f61&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33e42f61",
  null
  
)

export default component.exports